module.exports = __webpack_public_path__ + "img/shequ-9.33144d98.png";